import { environment } from '@app/environments/environment';

export const SloneekOriginHeader = 'X-Sloneek-Origin';

export function isSloneekApiRequest(url: string): boolean {
  return matchesOrigin(url, environment.backendUrl);
}

export function sloneekOriginHeaderValue(path: string): string {
  // `/terminal` also covers `/terminal-v2`.
  const platform = path.startsWith('/terminal') ? 'Terminal' : 'Web';
  return `${platform} v${environment.appVersionNumber}`;
}

function matchesOrigin(url: string, origin: string): boolean {
  const normalized = origin.replace(/\/$/, '');
  return normalized.length > 0 && (url === normalized || url.startsWith(`${normalized}/`));
}
